function scrollToResultsTop( section ) {
  const adminBar = document.getElementById( 'wpadminbar' );
  const adminBarHeight = adminBar ? adminBar.offsetHeight : 0;
  const headerHeight = document.querySelector( 'header' ).offsetHeight + adminBarHeight;

  const resultsWrapper = section.querySelector( '.e-stn--general-posts, .e-stn--resource-general-posts' );
  const sectionTop = section.getBoundingClientRect().top + window.scrollY - 25;
  const scrollTopPos = resultsWrapper ? ( resultsWrapper.getBoundingClientRect().top + window.scrollY ) : sectionTop;

  window.scrollTo( {
    top: scrollTopPos - headerHeight,
    behavior: 'smooth'
  } );
}

document.addEventListener( 'click', function( e ) {
  if ( e.target.classList.contains( 'facetwp-page' ) ) {
    const section = e.target.closest( 'section' );
    if ( section ) {
      scrollToResultsTop( section );
    }
  }
  if ( e.target.closest( '.facetwp-checkbox, .facetwp-radio' ) ) {
    const section = e.target.closest( 'section' );
    if ( section ) {
      scrollToResultsTop( section );
    }
  }
  const facetwpSearchInput = document.querySelector( '.facetwp-search' );
  if ( facetwpSearchInput ) {
    const parentFacet = facetwpSearchInput.closest( '.facetwp-facet-search' );
    // If the clicked element is the facetwp-search input
    if ( e.target === facetwpSearchInput ) {
      parentFacet.classList.add( 'facetwp-type-search-selected' );
    } else if ( !parentFacet.contains( e.target ) ) {
      parentFacet.classList.remove( 'facetwp-type-search-selected' );
    }
  }
} );

// FacetWP's own front-end only dims the sidebar facet widgets while refreshing
// (`.facetwp-facet.is-loading`); the results grid itself gives no feedback that
// a filter/page change is in flight. Mirror that same loading state onto the
// resource-center's grid wrapper so a click well below the fold doesn't read as inert.
document.addEventListener( 'facetwp-refresh', function() {
  const wrapper = document.querySelector( '.e-col--resource-general-posts-wrapper' );
  if ( wrapper ) {
    wrapper.classList.add( 'is-refreshing' );
  }
} );

document.addEventListener( 'facetwp-loaded', function() {
  const wrapper = document.querySelector( '.e-col--resource-general-posts-wrapper' );
  if ( wrapper ) {
    wrapper.classList.remove( 'is-refreshing' );
  }
} );
